import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const MessageWrapper = styled(Box)`
  display: flex;
  gap: 4px;
`;
